import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import SelectCountryCode from "~components/SelectCountryCode/SelectCountryCode.tsx";
import { TableFilter } from "~enums/tableFilter.ts";
import { SiteTableFilters } from "~pages/Sites/SiteListPage/enums/SiteTableFilters.ts";

export const useGetSiteTableFilters = (): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>({});
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);

  const filters = [
    {
      filterKey: SiteTableFilters.CountryCode,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectCountryCode
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.countryCode.allOption",
          })}
        />
      ),
    },
  ];

  return {
    filters: filters,
    currentFilter: currentFilter,
    handleFilterChange: handleFilterChange,
  };
};
